import type { StaffingWorkerLifecycleType } from './model';

export type WorkerPersonnelAction = Exclude<StaffingWorkerLifecycleType, 'HIRE'> | 'CORRECTION';

export const personnelActionTitles: Record<WorkerPersonnelAction, string> = {
  LEAVE_OF_ABSENCE: '휴직', RETURN_FROM_LEAVE: '복직', END_WORKER: '퇴직·계약 종료', CORRECTION: '입사일 정정',
};
export const personnelDateLabels: Record<WorkerPersonnelAction, string> = {
  LEAVE_OF_ABSENCE: '휴직 시작일', RETURN_FROM_LEAVE: '복직일', END_WORKER: '재직 종료일', CORRECTION: '정정할 입사일',
};
export const personnelStatusAfter = { LEAVE_OF_ABSENCE: '휴직', RETURN_FROM_LEAVE: '재직', END_WORKER: '종료' };

export function personnelStatusLabel(status: string | undefined) {
  if (!status) return undefined;
  return ({ DRAFT: '등록 중', '등록 중': '등록 중', ACTIVE: '재직', EMPLOYED: '재직', '재직': '재직', ON_LEAVE: '휴직', LEAVE_OF_ABSENCE: '휴직', SUSPENDED: '휴직', '휴직': '휴직', ENDED: '종료', TERMINATED: '종료', '퇴직': '종료', '종료': '종료', '퇴직 예정': '퇴직 예정', SCHEDULED: '입사 예정', '입사 예정': '입사 예정' } as Record<string, string>)[status] ?? '상태 확인 필요';
}

// 메뉴에서는 조회 기준일의 적합성만 안내합니다. 다른 날짜의 처리 가능 여부는 서버에서 다시 확인합니다.
export function personnelActionMatchesStatus(action: WorkerPersonnelAction, status: string | undefined) {
  const label = personnelStatusLabel(status);
  if (action === 'CORRECTION') return true;
  if (action === 'LEAVE_OF_ABSENCE') return label === '재직';
  if (action === 'RETURN_FROM_LEAVE') return label === '휴직';
  return ['재직', '휴직', '퇴직 예정'].includes(label ?? '');
}

export function validPersonnelDate(date: string) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return false;
  const parsed = new Date(`${date}T00:00:00Z`);
  return Number.isFinite(parsed.valueOf()) && parsed.toISOString().slice(0, 10) === date;
}

export function validateLeaveDetails(effectiveDate: string, leaveType: string, expectedReturnDate: string) {
  if ([...leaveType.trim()].length > 100) return '휴직 유형은 100자 이내로 입력해 주세요.';
  if (expectedReturnDate && (!validPersonnelDate(expectedReturnDate) || expectedReturnDate <= effectiveDate)) return '복직 예정일은 휴직 시작일 다음 날부터 입력할 수 있습니다.';
  return undefined;
}

export function leaveDurationDays(startDate: string, returnDate: string) {
  if (!validPersonnelDate(startDate) || !validPersonnelDate(returnDate) || returnDate <= startDate) return undefined;
  return Math.round((Date.parse(`${returnDate}T00:00:00Z`) - Date.parse(`${startDate}T00:00:00Z`)) / 86_400_000);
}
